import type { EndpointsMap } from '../endpoints';
import type { HttpMethod, IconikApiHeaders } from '../types';

export type EndpointId = keyof EndpointsMap;

export type EndpointRequest<Meta extends object = Record<string, unknown>> = {
  id: EndpointId;
  method: HttpMethod;
  url: string;
  params?: Record<string, string>;
  host?: string;
  headers?: IconikApiHeaders;
  query?: unknown;
  body?: unknown;
  meta?: Meta;
  abortSignal?: AbortSignal;
};

export const isEndpointRequest = (obj: any): obj is EndpointRequest =>
  obj && obj.id && obj.method && obj.url;
